import common from "@/pages/adminPanel/common.module.scss";
import styles from "./sertificates.module.css";
import { useState } from "react";
import { createSertificateLink } from "./SertificatesApi";
import { toast } from "react-toastify";

const Sertificates = () => {
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);

  const mail = import.meta.env.VITE_APP_SERTIFICATE_EMAIL;

  const handleCreate = async () => {
    if (!price || Number(price) <= 0) {
      toast.error("Введите корректную стоимость");
      return;
    }
    if (!description || description.trim().length < 1) {
      toast.error("Введите описание");
      return;
    }

    try {
      setLoading(true);
      setLink("");

      const res = await createSertificateLink(
        Number(price),
        description,
        mail
      );

      setLink(res?.data?.confirmationUrl || "");
      toast.success("Ссылка успешно создана");
    } catch (e) {
      toast.error(`Ошибка создания: ${e?.response?.data?.message || e.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Ссылка скопирована");
    } catch {
      toast.error("Не удалось скопировать ссылку");
    }
  };

  return (
    <div className={`container-fluid ${common.container} h-100`}>
      <div className="d-flex align-items-center gap-2 mb-3">
        <label>Стоимость сертификата</label>
        <input
          type="number"
          min="0"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          className={`form-control ${styles.input}`}
          placeholder="Стоимость"
        />
      </div>

      <div className="d-flex align-items-center gap-2 mb-3">
        <label>Описание</label>
        <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className={`form-control ${styles.input}`}
            placeholder="Описание"
        />
      </div>

      {link && (
        <div className={styles.linkCard}>
          <div className={styles.linkHeader}>
            <span className={styles.linkTitle}>Ссылка на оплату создана</span>
          </div>

          <a
            href={link}
            className={styles.link}
            target="_blank"
            rel="noreferrer"
            title={link}
          >
            {link}
          </a>

          <div className="d-flex gap-2 mt-2">
            <button className="service-btn" onClick={handleCopy}>
              Скопировать
            </button>

            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className={styles.openBtn}
            >
              Открыть
            </a>
          </div>
        </div>
      )}

      <button
        className="service-btn mt-3"
        onClick={handleCreate}
        disabled={loading}
      >
        {loading ? "Создание..." : "Создать"}
      </button>
    </div>
  );
};

export default Sertificates;
